module.exports = __webpack_public_path__ + "static/media/avatar-7.9524b09f.jpg";